import { OdataManager } from '@/api/odata/odata-manager';
import { CertifiersImport } from '@/api/model/interfaces';

export default class CertifiersImportOdata extends OdataManager<CertifiersImport> {}
